<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :class="tableClass"
      :headers="filteredHeaders"
      :items="itemsList"
      :hide-default-footer="true"
      :items-per-page="itemsList.length"
    >
      <template #[`item.actions`]="{ item }">
        <template v-if="item.uzsakoma">
          <v-progress-circular
            size="24"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </template>
        <template v-if="!item.uzsakoma">
          <el-button-icon
            v-for="uzsakyti in item.uzsakyti"
            :key="uzsakyti.israso_tipas"
            primary
            small
            :loading="loadingUzsakyti"
            :icon="uzsakyti.icon"
            @click.native="confirmUzsakytiIsrasas(item, uzsakyti)"
          >
            {{ uzsakyti.text }}
          </el-button-icon>
        </template>

        <el-button
          v-if="item.canXml"
          :key="item.xmlID"
          x-small
          @click.native="paieskaObjXml(item.obj_identifikavimo_kodas)"
          >XML</el-button
        >
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../mixins/math'
import userRole from '../../mixins/userRole'

export default {
  name: 'PaieskaResultAsmenys',
  props: {
    asmenys: Array,
    paiTipas: String,
  },
  mixins: [math, userRole],
  data() {
    return {
      loading: false,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      paieska: {
        pai_parametrai: [],
        expired: false,
        atsakymas: null,
        rezultatai: [
          {
            uzsakoma: false,
          },
        ],
        bylos: [],
      },
      showConfirm: false,
      confirmTitle: null,
      confirmText: null,
      confirmItem: null,
      confirmUzsakyti: null,
      loadingUzsakyti: false,

      lockInterval: null,
      lockTimeoutFull: 1000,
      lockTimeoutMinimal: 10000,
    }
  },
  computed: {
    ...mapGetters(['paieskaKaina']),

    headers() {
      return [
        {
          text: 'Asmuo įrašytas registre kaip',
          align: 'start',
          value: 'sasm_role_objekte',
          hide: !(this.isJuridinis || this.isFizinis),
        },
        {
          text: 'Turto unikalus numeris',
          align: 'start',
          value: 'tur_identifikatorius',
          hide: this.isKodas,
        },
        {
          text: 'Turto rūšis',
          align: 'start',
          value: 'tur_rusis_pavadinimas',
          hide: this.isKodas,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.asmenys.map((item, index) => {
        item.canXml = !item.uzsakoma && this.isLocal
        return item
      })
    },
    tableClass() {
      return 'miniTable'
    },
    isMinimal() {
      return this.minimal
    },
    isJuridinis() {
      return this.paiTipas === 'juridinis'
    },
    isFizinis() {
      return this.paiTipas === 'fizinis'
    },
    isTurtas() {
      return this.paiTipas === 'turtas'
    },
    isKodas() {
      return this.paiTipas === 'kodas'
    },
    isLocal() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop' ||
        process.env.VUE_APP_LOCAL === 'preprod'
      )
    },
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
